module.exports = __webpack_public_path__ + "media/turn_pages.56d8cd3b.mp3";